import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
import { SectionHeading } from './SectionHeading';
export function Faqs() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-heading" className="bg-mist py-16 sm:py-24" data-id="element-30" data-mp="356okovmak3fh">
      <div className="mx-auto max-w-3xl px-5 sm:px-6" data-id="element-31" data-mp="3a585gsp5f969">
        <SectionHeading id="faq-heading" tone="light" eyebrow="Najczęstsze pytania" data-id="element-32" data-mp="3a4pz338rvekm">
          Zanim <span className="text-gold-dark" data-id="element-33" data-mp="3f318jcv5nn2b">zdecydujesz</span>
        </SectionHeading>
        <div className="mt-10 space-y-3" data-id="element-34" data-mp="3k4gvxbkt25nv">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className={`rounded-xl border bg-white shadow-card transition-colors duration-150 ease-out ${isOpen ? 'border-gold' : 'border-copy-dark/10'}`} data-id="element-35" data-mp="3o2od27j6l8zl" data-mpi={index}>
                <h3 data-id="element-36" data-mp="2hd1xlzia0gab">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-5 px-5 py-4 text-left sm:px-6 sm:py-5" data-id="element-37" data-mp="2hdlinp383ksk">
                    <span className="text-base font-bold leading-snug text-copy-dark" data-id="element-38" data-mp="3091wlu9o8k3e">{faq.question}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-gold-dark transition-transform duration-150 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-39" data-mp="2vbt8ld1udlu8" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-40" data-mp="1ey32y1v2qpih">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-41" data-mp="19xfcpieo6cpb">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-copy-muted sm:px-6 sm:text-base" data-id="element-42" data-mp="3t3zvu1m3fkfw">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}